import {Table} from "../../../components/layout";
import {ColumnDef} from "@tanstack/react-table";
import CellRender from "../../../components/layout/table/CellRender";
import {BackendVersion} from "fearless-common/src/backendModels";
import {Reagent} from "fearless-common";

const columns: ColumnDef<BackendVersion<Reagent>>[] = [
  {
    id: 'id',
    header: 'ID',
    accessorKey: 'version_id'
  },
  {
    id: 'user',
    header: 'Created by',
    accessorKey: 'user',
    cell: CellRender.FullName,
  },
  {
    id: 'updated_at', accessorKey: 'updated_at', header: 'Date', cell: CellRender.DateTime, enableSorting: true,
  },
  {
    id: 'model',
    accessorKey: 'model',
    header: 'Model data',
    cell: ({ getValue }) => {
      const modelData = getValue() as Record<string, any>;
      return <pre style={{ maxWidth: '500px', whiteSpace: 'pre-wrap' }}>{JSON.stringify(modelData) || '-'}</pre>
    }
  }
];

export default function ReagentVersionsTable({ versions }: {
  versions: Array<BackendVersion<Reagent> & { model: any }>
}) {
  return (
    <Table memoisedColumns={columns} memoisedData={versions} />
  )
}
